import { render } from "./ImprintView.vue?vue&type=template&id=d2710a3a&scoped=true"
const script = {}

import "./ImprintView.vue?vue&type=style&index=0&id=d2710a3a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2710a3a"]])

export default __exports__